import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";
import { Button, Grid, MenuItem, TextField } from "@mui/material";

function buildMonthOptions() {
  const now = new Date();
  const options = [];

  for (let i = 0; i < 24; i += 1) {
    const date = new Date(now.getFullYear(), now.getMonth() - i, 1);
    const value = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}`;
    const label = date.toLocaleString("default", {
      month: "long",
      year: "numeric",
    });

    options.push({ value, label });
  }

  return options;
}

export default function PayrollRunPicker({ onSelected, withMonth }) {
  const monthOptions = useMemo(() => buildMonthOptions(), []);
  const [selectedMonth, setSelectedMonth] = useState(monthOptions[0]?.value || "");

  const handleSubmit = () => {
    if (onSelected) {
      onSelected(selectedMonth);
    }
  };

  return (
    <Grid container spacing={2} alignItems="center">
      {withMonth ? (
        <Grid item xs={12} md={6}>
          <TextField
            select
            fullWidth
            label="Payroll Month"
            value={selectedMonth}
            onChange={(event) => setSelectedMonth(event.target.value)}
          >
            {monthOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      ) : null}

      <Grid item xs={12} md="auto">
        <Button variant="contained" onClick={handleSubmit}>
          Load
        </Button>
      </Grid>
    </Grid>
  );
}

PayrollRunPicker.propTypes = {
  onSelected: PropTypes.func,
  withMonth: PropTypes.bool,
};

PayrollRunPicker.defaultProps = {
  onSelected: null,
  withMonth: true,
};
